const config = {
    api_url: {
        dev: "https://svelte-elastic:3030",
        prod: "https://svelte-wp2.frida.tech:8443",
        test: "https://svelte-wp-dev2.frida.tech:8443",
    },
    2: {
        elasticSearch: {
            aggs_size: 100,
            aggs_top_hits: 100,
            search_by: "tag",
        },
    },
};
export default config;
